"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
exports.SendStepPanel = props => {
    const { children, title, activeStep, description, noPadding, footer, step: { invalid, successful, id }, } = props;
    const isActive = activeStep === id;
    const isFirstStep = id === 0;
    const opacity = successful || isActive ? 1 : 1.05 - (id - activeStep) * 0.25;
    const color = invalid
        ? 'danger'
        : successful
            ? 'success'
            : isActive
                ? 'primary'
                : 'light';
    const icon = (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: invalid
            ? pro_solid_svg_icons_1.faTimesCircle
            : successful
                ? pro_solid_svg_icons_1.faCheckCircle
                : pro_solid_svg_icons_1.faArrowCircleRight, style: { opacity: isFirstStep ? 0 : 1 }, className: `text-${color}`, size: "2x" }));
    return (react_1.default.createElement(react_2.OsmosysDiv, { flexCol: true },
        react_1.default.createElement(react_2.OsmosysDiv, { className: classnames_1.default('my-2 ', !noPadding && 'py-2'), flexRow: true },
            react_1.default.createElement(react_2.OsmosysDiv, { flexCol: true, className: classnames_1.default('mx-3 flex-grow-0 position-relative'), flexGrow: 0, style: {
                    opacity,
                } }, isFirstStep ? (icon) : (react_1.default.createElement(react_2.OsmosysTooltip, { label: `Step ${id}` }, icon))),
            react_1.default.createElement(react_2.OsmosysDiv, { flexColFilled: true },
                react_1.default.createElement(react_2.OsmosysDiv, { style: {
                        opacity,
                    }, flexColFilled: true },
                    title && (react_1.default.createElement("h5", null,
                        react_1.default.createElement("strong", null, title))),
                    description && react_1.default.createElement("p", { className: "my-2" }, description),
                    children),
                react_1.default.createElement(react_if_1.When, { condition: !!footer },
                    react_1.default.createElement(react_2.OsmosysDiv, { className: "my-3 flex-grow-1", flexCol: true },
                        react_1.default.createElement("div", { className: "flex-grow-1" }, footer)))))));
};
//# sourceMappingURL=SendStepPanel.js.map